import { reactive } from 'vue';
import { IState } from '@/models/store/store.interface';
import { Routes } from '@/models/router/router.interface';

const state = reactive<IState>({
	errorMessage: '',
	router: {
		current: Routes.IMPORT_FILE,
		props: {
			id: '0'
		}
	},
	selectedFileUpload: null,
	standAloneLogin: false,
	storedImports: []
});

export default state;
